/* MIIM.MIIC homepage — scroll reveal, hero video, pillars, review rail, add-to-cart */
(function () {
  function init(root) {
    root = root || document;
    var scope = root.querySelector ? root : document;

    document.documentElement.classList.add('loaded');

    // hero / launch video autoplay
    scope.querySelectorAll('video[data-hero-video]').forEach(function (el) {
      el.muted = true; el.defaultMuted = true; el.volume = 0;
      el.setAttribute('muted', ''); el.loop = true; el.setAttribute('loop', '');
      var go = function () { var p = el.play(); if (p && p.catch) p.catch(function () {}); };
      go(); el.addEventListener('canplay', go, { once: true });
    });

    // scroll progress
    var bars = document.querySelectorAll('[data-progress]');
    if (bars.length) {
      var onScroll = function () {
        var h = document.documentElement;
        var max = h.scrollHeight - h.clientHeight;
        var p = max > 0 ? Math.min(100, (h.scrollTop / max) * 100) : 0;
        bars.forEach(function (b) { b.style.width = p.toFixed(1) + '%'; });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // scroll reveal
    var nodes = scope.querySelectorAll('.reveal,.reveal-grid');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.05 });
      nodes.forEach(function (n) { io.observe(n); });
    } else {
      nodes.forEach(function (n) { n.classList.add('in'); });
    }

    // pillar switcher
    var pills = scope.querySelectorAll('[data-pill]');
    pills.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var n = btn.getAttribute('data-pill');
        pills.forEach(function (b) { b.setAttribute('data-active', b.getAttribute('data-pill') === n ? 'on' : 'off'); });
        scope.querySelectorAll('.ppanel .pface').forEach(function (p, i) {
          p.setAttribute('data-active', String(i + 1) === n ? 'on' : 'off');
        });
      });
    });

    // review rail
    scope.querySelectorAll('[data-rail]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var rail = document.getElementById('review-rail');
        if (!rail) return;
        var card = rail.querySelector('.cell');
        var step = card ? card.offsetWidth + 2 : rail.clientWidth * 0.8;
        rail.scrollBy({ left: parseInt(btn.getAttribute('data-rail'), 10) * step, behavior: 'smooth' });
      });
    });

    // presentational add-to-cart
    scope.querySelectorAll('[data-atc]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.classList.contains('added')) return;
      var variantId = b.dataset.variantId;
      if (!variantId) return;

      addToCart([{ id: parseInt(variantId, 10), quantity: 1 }]);
      
        var label = b.textContent;
        b.classList.add('added');
        b.textContent = 'Added \u2713';
        setTimeout(function () { b.classList.remove('added'); b.textContent = label; }, 1800);
      });
    });
  }


  /* ---------- shared add-to-cart core ---------- */
  /* items: array of { id, quantity } — works for a single product OR the 3-item bundle */
  function addToCart(items) {
    var dsid = getDrawerSectionId();
    var body = { items: items };
    if (dsid) {
      body.sections = dsid;
      body.sections_url = window.location.pathname || '/';
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        if (!r.ok)
          return r.json().then(function (e) {
            throw e;
          });
        return r.json();
      })
      .then(function (data) {
        if (dsid && data.sections && data.sections[dsid]) replaceDrawer(data.sections[dsid]);
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            var cnt = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
            updateCartCount(cnt);
            ['theme:cart:reload', 'theme:cart:change', 'cart:refresh', 'cart:change', 'cart:updated'].forEach(
              function (e) {
                try {
                  document.dispatchEvent(new CustomEvent(e, { bubbles: true, detail: cart }));
                } catch (_) {}
              }
            );
            setTimeout(function () {
              updateCartCount(cnt);
            }, 150);
            setTimeout(function () {
              updateCartCount(cnt);
            }, 500);
            setTimeout(openDrawer, 120);
            return data;
          });
      });
  }

  function getDrawerSectionId() {
    var w = document.querySelector('[data-section-type="cart-drawer"]');
    if (w && w.dataset.sectionId) return w.dataset.sectionId;
    var d = document.querySelector('cart-drawer#cart-drawer') || document.querySelector('cart-drawer');
    if (d) {
      var pEl = d.closest('[data-section-id]');
      if (pEl) return pEl.dataset.sectionId;
    }
    return null;
  }

  function updateCartCount(n) {
    n = parseInt(n, 10);
    if (isNaN(n) || n < 0) n = 0;
    document.querySelectorAll('cart-count').forEach(function (elx) {
      elx.setAttribute('data-cart-count', n);
      var lim = parseInt(elx.dataset.limit, 10);
      elx.textContent = !isNaN(lim) && lim > 0 && n > lim ? lim + '+' : String(n);
    });
    [
      '[data-cart-count]:not(cart-count)',
      '.cart-count',
      '.cart__count',
      '.cart-item-count',
      '.header__cart-count',
      '.cart-link__bubble-num',
      '[data-item-count]',
    ].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (elx) {
        elx.textContent = String(n);
        if (elx.hasAttribute('data-cart-count')) elx.setAttribute('data-cart-count', n);
        if (elx.hasAttribute('data-item-count')) elx.setAttribute('data-item-count', n);
      });
    });
  }

  function replaceDrawer(html) {
    if (!html) return;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nd = doc.querySelector('cart-drawer');
      var od = document.querySelector('cart-drawer#cart-drawer') || document.querySelector('cart-drawer');
      if (nd && od) {
        var open = [];
        ['is-active', 'active', 'open', 'is-open', 'drawer--open'].forEach(function (c) {
          if (od.classList.contains(c)) open.push(c);
        });
        var imp = document.importNode(nd, true);
        od.parentNode.replaceChild(imp, od);
        open.forEach(function (c) {
          imp.classList.add(c);
        });
        imp.querySelectorAll('script').forEach(function (os) {
          var ns = document.createElement('script');
          Array.prototype.forEach.call(os.attributes, function (a) {
            ns.setAttribute(a.name, a.value);
          });
          ns.textContent = os.textContent;
          os.parentNode.replaceChild(ns, os);
        });
      }
    } catch (e) {
      console.error('[MIIM.MIIC] Drawer swap:', e);
    }
  }

  function openDrawer() {
    var d = document.querySelector('cart-drawer#cart-drawer') || document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') {
      try {
        d.open();
        return;
      } catch (e) {}
    }
    var t =
      document.querySelector('[data-action="open-drawer"][data-drawer-id="cart-drawer"]') ||
      document.querySelector('[aria-controls="cart-drawer"]:not([data-cart-drawer-close])') ||
      document.querySelector('.navlink--cart') ||
      document.querySelector('[data-cart-toggle]');
    if (t) {
      try {
        t.click();
        return;
      } catch (e) {}
    }
    ['theme:drawer:open', 'drawer:open', 'cart-drawer:open'].forEach(function (e) {
      try {
        document.dispatchEvent(new CustomEvent(e, { bubbles: true, detail: { drawer: 'cart-drawer' } }));
      } catch (_) {}
    });
    if (d) {
      d.classList.add('is-active', 'active', 'open', 'is-open', 'drawer--open');
      d.removeAttribute('hidden');
    }
  }



  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
